export class CallLangs {

	// supported langs from https://developers.deepgram.com/docs/models-languages-overview#nova-3
	public static LANGS = [
		{ code: 'ar', name: 'Arabic' },
		{ code: 'be', name: 'Belarusian' },
		{ code: 'bn', name: 'Bengali' },
		{ code: 'bs', name: 'Bosnian' },
		{ code: 'bg', name: 'Bulgarian' },
		{ code: 'ca', name: 'Catalan' },
		{ code: 'zh', name: 'Chinese' },
		{ code: 'hr', name: 'Croatian' },
		{ code: 'cs', name: 'Czech' },
		{ code: 'da', name: 'Danish' },
		{ code: 'nl', name: 'Dutch' },
		{ code: 'en', name: 'English' },
		{ code: 'et', name: 'Estonian' },
		{ code: 'fi', name: 'Finnish' },
		{ code: 'fr', name: 'French' },
		{ code: 'de', name: 'German' },
		{ code: 'el', name: 'Greek' },
		{ code: 'he', name: 'Hebrew' },
		{ code: 'hi', name: 'Hindi' },
		{ code: 'hu', name: 'Hungarian' },
		{ code: 'id', name: 'Indonesian' },
		{ code: 'it', name: 'Italian' },
		{ code: 'ja', name: 'Japanese' },
		{ code: 'kn', name: 'Kannada' },
		{ code: 'ko', name: 'Korean' },
		{ code: 'lv', name: 'Latvian' },
		{ code: 'lt', name: 'Lithuanian' },
		{ code: 'mk', name: 'Macedonian' },
		{ code: 'ms', name: 'Malay' },
		{ code: 'mr', name: 'Marathi' },
		{ code: 'no', name: 'Norwegian' },
		{ code: 'fa', name: 'Persian' },
		{ code: 'pl', name: 'Polish' },
		{ code: 'ptbr', name: 'Portuguese (Brazilian)' },
		{ code: 'pt', name: 'Portuguese (European)' },
		{ code: 'ro', name: 'Romanian' },
		{ code: 'ru', name: 'Russian' },
		{ code: 'sr', name: 'Serbian' },
		{ code: 'sk', name: 'Slovak' },
		{ code: 'sl', name: 'Slovenian' },
		{ code: 'es', name: 'Spanish' },
		{ code: 'sv', name: 'Swedish' },
		{ code: 'tl', name: 'Tagalog' },
		{ code: 'ta', name: 'Tamil' },
		{ code: 'te', name: 'Telugu' },
		{ code: 'th', name: 'Thai' },
		{ code: 'tr', name: 'Turkish' },
		{ code: 'uk', name: 'Ukrainian' },
		{ code: 'ur', name: 'Urdu' },
		{ code: 'vi', name: 'Vietnamese' },
	]

	// Multilingual (English, Spanish, French, German, Hindi, Russian, Portuguese, Japanese, Italian, and Dutch)
	public static MULTI_LANGS = [
		'en',
		'es',
		'fr',
		'de',
		'hi',
		'ru',
		'pt', 'ptbr',
		'ja',
		'it',
		'nl',
	]

	public static isLangMulti (
		lang: string
	): boolean {
		return this.MULTI_LANGS.includes(lang);
	}
}
